import { observable, configure, action } from 'mobx';
import LocalModel from './localModel';

import util from 'preact-util';

configure({ enforceActions: 'always' });

class NdaAcceptanceStore extends LocalModel {
    constructor() {
        super('ndaAcceptance', {
            namePlural: 'ndaAcceptances',
            namePluralReal: 'ndaacceptances',
            sort: '-acceptedDate',
            limit: 100,
            api: {
                search: {
                    url: '/api/ndaacceptances/',
                    params: {
                        limit: 100,
                        sort: '-acceptedDate',
                    },
                },
                load: {
                    url: '/api/ndaacceptances/',
                    params: {},
                },
                save: {
                    url: '/api/ndaacceptances/',
                    params: {},
                },
            },
        });
    }

    @observable newNdaAcceptance = {};

    @observable ndaAcceptance = {};

    @observable ndaAcceptances = [];

    @action
    clearAll() {
        this.newNdaAcceptance = {};
        this.ndaAcceptance = {};
        this.ndaAcceptances = [];
    }

    async recordAcceptance({ ndaDocument, signerName, signerEmail, signerCompany, visitor, notes }) {
        const response = await util.fetchApi('/api/ndaacceptances/', {
            method: 'POST',
        }, {
            ndaDocument,
            signerName,
            signerEmail,
            signerCompany,
            visitor,
            notes,
        });

        if (response.status === 201) {
            await this.load();
        }

        return response;
    }

    async revokeAcceptance(acceptanceId) {
        const response = await util.fetchApi(`/api/ndaacceptances/${acceptanceId}`, {
            method: 'PATCH',
        }, {
            id: acceptanceId,
            status: 'revoked',
        });

        if (response.status === 202) {
            await this.load();
        }

        return response;
    }
}

const store = new NdaAcceptanceStore();
export default store;
